import { render, staticRenderFns } from "./FollowList.vue?vue&type=template&id=652d6356&scoped=true&"
import script from "./FollowList.vue?vue&type=script&lang=js&"
export * from "./FollowList.vue?vue&type=script&lang=js&"
import style0 from "./FollowList.vue?vue&type=style&index=0&id=652d6356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d6356",
  null
  
)

export default component.exports